var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "history-order-popup",
      attrs: { visible: _vm.$f.orderOpened },
      on: {
        "on-close": function($event) {
          return _vm.$f.hideOldOrderPopup()
        }
      }
    },
    [
      _c("order-card", {
        attrs: {
          "order-number": _vm.$f.currentOrderNumber,
          "is-last": "",
          "show-support-info": "",
          "is-expanded-default": ""
        },
        on: { "on-close": _vm.toOrders }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }